import { Modal } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  Box, Button, CircularProgress,
  Stack, Typography
} from "@mui/material";
import { AlertColor } from '@mui/material/Alert';
import { t } from "i18next";
import { useEffect, useState } from "react";
import { DeleteVr } from "../../../services/ValidationRuleService";

interface IValidationRuleModalDeleteComp {
  onClose: () => void;
  show: boolean;
  idVrDelete?: string | number;
  setSeverity: (set: AlertColor) => void;
  setMessage: (set: string | undefined) => void;
}

export const ValidationRuleModalDeleteComp: React.FC<IValidationRuleModalDeleteComp> = ({ onClose, show, idVrDelete, setSeverity, setMessage }) => {
  const [isModalOpen, { setTrue: showModal, setFalse: hideModal }] = useBoolean(show);
  const [waiting, setWaiting] = useState<boolean>(false);

  useEffect(() => {
    if (show) showModal();
  }, [show]);

  function deleteDocumentTypePopup() {
    DeleteVr(idVrDelete as string)
      .then(() => {
        setSeverity("success");
        setMessage(t("ValidationRules.DeletedOk"));
        onCloseModal();
      })
      .catch((error) => {
        setSeverity("error");
        setMessage(error.response.data);
        onCloseModal();
      });
  }

  const onCloseModal = () => {
    hideModal();
    onClose();
  };

  return (
      <Modal
        isOpen={isModalOpen}
        aria-labelledby="delete-modal-title"
        aria-describedby="delete-modal-description"
        styles={{
          main: {
            borderRadius: "10px"
          }
        }}
      >
        <Box sx={{
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: "10px",
          width: "600px",
          height: "260px",
          textAlign: 'center'
        }}>
          {waiting ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 3 }}>
              <CircularProgress />
            </Box>
          ) : (
            <>
              <DeleteIcon sx={{ fontSize: 40, color: '#22638D', mb: 2 }} />
              <Typography id="delete-modal-title" variant="h6" gutterBottom>
                {t("ValidationRule.DeleteVr")}
              </Typography>
              <Typography id="delete-modal-description" sx={{ mb: 4 }}>
                {t("ValidationRule.ConfirmDelete")}
              </Typography>
              <Stack direction="row" spacing={2} justifyContent="center">
                <Button
                  variant="outlined"
                  onClick={onCloseModal}
                  sx={{ borderColor: '#22638D', color: '#22638D' }}
                  fullWidth
                >
                  {t("Cancelar.message") || "Cancelar"}
                </Button>
                <Button
                  variant="contained"
                  onClick={deleteDocumentTypePopup}
                  sx={{ backgroundColor: '#22638D', color: '#FFFFFF', '&:hover': { backgroundColor: '#1A4E6B', opacity: 1 } }}
                  fullWidth
                >
                  {t("Confirmar.message") || "Confirmar"}
                </Button>
              </Stack>
            </>
          )}
        </Box>
      </Modal>
  );
};
